



































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "transactions-total": () =>
      import("@/components/app/global/stats/transactionsTotal.vue"),
    "transactions-average-value": () =>
      import("@/components/app/global/stats/transactionsAverageValue.vue"),
    "chart-transactions": () =>
      import("@/components/app/global/stats/charts/transactionsChart.vue")
  }
})
export default class AdminClientsOverview extends Vue {
  @Prop({ required: false, default: [] })
  public routes!: any[];

  @Prop({ required: false, default: null })
  public range!: any[];

  @Prop({ required: false, default: null })
  public currencyCode!: string;

  // Data
  public tableId = "TT1";
}
